import PersonIcon from "@mui/icons-material/Person";
import { Box, Grid } from "@mui/material";

import User from "../../interfaces/User";
import { theme } from "../../mui-customs/Theme";
import NoDataUI from "../NoDataUI";
import ChefProfileCard from "./ChefProfileCard";

interface BrowseChefsTabProps {
  chefs: User[];
  isLoading: boolean;
}

const BrowseChefsTab = ({ chefs, isLoading }: BrowseChefsTabProps) => {
  return (
    <Box sx={{ backgroundColor: theme.whiteBg.WBG1, p: 3 }}>
      {chefs.length > 0 ? (
        <Grid container spacing={3}>
          {chefs.map((chef, index) => {
            return (
              <Grid key={index} item xs={12} md={6}>
                <ChefProfileCard chef={chef} />
              </Grid>
            );
          })}
        </Grid>
      ) : (
        !isLoading && (
          <NoDataUI Icon={PersonIcon} displayMessage={"No chef available "} />
        )
      )}
    </Box>
  );
};

export default BrowseChefsTab;
